module.exports = __webpack_public_path__ + "static/media/7.1f0f2f4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/7.png
// module id = 1173
// module chunks = 0